<div class="okta-container">
    <div class="row okta-wrapper">
      <div class="okta-form-row">
        <div class="row logo-holder">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 logo-block">
            <img class="app-logo" src="/assets/images/{{websiteName}}/LogoNew.png" alt="" />
          </div>
        </div>
        <div class="row box-container">
          <form novalidate (ngSubmit)="onUnlockAccountSubmit()">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <p class="exp-message">Unlock Account</p>
              <div class="has-error okta-error" *ngIf="unlock.errorMessage">
                <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
                <p class="show-message">
                  <span title="{{unlock.errorMessage}}">{{unlock.errorMessage}}</span>
                </p>
              </div>
              <ul class="form-grid">
                <li class="password-hint">
                  <p>Please enter the username you use for access to parmed.com and submit your unlock account request. You will receive
                    an email with a link to unlock your account.</p>
                </li>
                <li>
                  <mat-form-field>
                    <input id="username" matInput required name="username" placeholder="Username" [(ngModel)]="unlock.username" parAutoFocus>
                  </mat-form-field>
                </li>
                <li>
                  <div class="okta-action-buttons">
                    <button id="btn-cancel" type="button" mat-raised-button color="accent" (click)="onCancelClick()">Back To Home</button>
                    <button id="btn-submit" type="submit" mat-raised-button color="accent">Unlock Via Email</button>
                  </div>
                </li>
              </ul>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>